import { render } from "./TheConsumersList.vue?vue&type=template&id=40ec3e64"
import script from "./TheConsumersList.vue?vue&type=script&lang=js"
export * from "./TheConsumersList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__